import React, { useState } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";

const HandOutContent = ({ handoutData, videoData, onDocumentSelect, purchase }: any) => {
  const [isContentVisible, setIsContentVisible] = useState(true);

  const handleDocumentClick = (doc: any) => {
    onDocumentSelect(doc);
  };

  const toggleContentVisibility = () => {
    setIsContentVisible(!isContentVisible);
  };

  return (
    <Box
      width={isContentVisible ? { xs: "360px", md: "450px" } : "44px"}
      height={"587px"}
    >
      <Box
        display={"flex"}
        p={isContentVisible ? 2 : 1}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        {isContentVisible ? (
          <>
            <Typography fontSize={"20px"} fontWeight={700} color={"#5C5C5C"}>
              Handout content
            </Typography>
            <ClearOutlinedIcon
              sx={{ color: "gray", cursor: "pointer", mr: 2 }}
              onClick={toggleContentVisibility}
            />
          </>
        ) : (
          <KeyboardDoubleArrowLeftIcon
            sx={{ color: "gray", cursor: "pointer" }}
            onClick={toggleContentVisibility}
          />
        )}
      </Box>
      {isContentVisible && (
        <Box
          className="custom-scrollbar"
          p={{ xs: "5px", md: 1 }}
          sx={{ maxHeight: "500px", overflowY: "scroll" }}
        >
          {purchase?.contentData?.contentStructure?.map((file: any, fileIndex: any) => (
            <Accordion
              key={fileIndex}
              defaultExpanded
              sx={{ backgroundColor: "#F3F3F3", mb: 1 }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography
                  fontSize={{ xs: "14.96px", md: "18px" }}
                  fontWeight={700}
                  color={"#233F91"}
                >
                  {file?.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ py: 0, display: "flex", gap: 3 }}>
                <List>
                  {file?.files?.map((file: any, fileIndex: number) => (
                    <ListItem
                      key={fileIndex}
                      sx={{ pl: 0, cursor: "pointer" }}
                      onClick={() => handleDocumentClick(file)}
                    >
                      <ListItemIcon sx={styleSheet.pdfListItem}>
                        {file.type === "pdf" || file.type === "image" ? (
                          <InsertDriveFileIcon sx={{ color: "#595959" }} />

                        ) : (
                          <PlayCircleOutlineIcon sx={{ color: "#595959" }} />
                        )}
                        <ListItemText
                          sx={{ width: "140px" }}
                          primary={file.name} // Display the name of the file
                        />
                      </ListItemIcon>
                      <IconButton
                        aria-label="download"
                        href={file.fileUrl}
                        download
                        sx={styleSheet.downloadBtn}
                      >
                        <img
                          src="/assets/icons/downloadhandout.png"
                          alt="download"
                          style={{ width: "100%", height: "100%" }}
                        />
                      </IconButton>
                    </ListItem>
                  ))}
                </List>
              </AccordionDetails>
            </Accordion>
          ))}
          {/* {handoutData?.map((section: any, sectionIndex: any) => (
            <Accordion
              key={sectionIndex}
              defaultExpanded
              sx={{ backgroundColor: "#F3F3F3", mb: 1 }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography
                  fontSize={{ xs: "14.96px", md: "18px" }}
                  fontWeight={700}
                  color={"#233F91"}
                >
                  {section.section}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ py: 0, display: "flex", gap: 3 }}>
                <List>
                  {section.files.map((file: any, fileIndex: any) => (
                    <ListItem
                      key={fileIndex}
                      sx={{ pl: 0, cursor: "pointer" }}
                      onClick={() => handleDocumentClick(file)}
                    >
                      <ListItemIcon sx={styleSheet.pdfListItem}>
                        {file.type === "pdf" ? (
                          <InsertDriveFileIcon sx={{ color: "#595959" }} />
                        ) : (
                          <PlayCircleOutlineIcon sx={{ color: "#595959" }} />
                        )}
                        <ListItemText
                          sx={{ width: "140px" }}
                          primary={file.title}
                        />
                      </ListItemIcon>
                      <IconButton
                        aria-label="download"
                        href={file.url}
                        download
                        sx={styleSheet.downloadBtn}
                      >
                        <img
                          src="/assets/icons/downloadhandout.png"
                          alt="download"
                        />
                      </IconButton>
                    </ListItem>
                  ))}
                </List>
              </AccordionDetails>
            </Accordion>
          ))}
          {videoData.map((section: any, sectionIndex: any) => (
            <Accordion
              key={sectionIndex}
              defaultExpanded
              sx={{ backgroundColor: "#F3F3F3", mb: 1 }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography
                  fontSize={{ xs: "14.96px", md: "18px" }}
                  fontWeight={700}
                  color={"#233F91"}
                >
                  {section.section} Videos
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ py: 0, display: "flex", gap: 3 }}>
                <List>
                  {section.videos.map((video: any, videoIndex: any) => (
                    <ListItem
                      key={videoIndex}
                      sx={{ pl: 0, cursor: "pointer" }}
                      onClick={() => handleDocumentClick(video)}
                    >
                      <ListItemIcon
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <PlayCircleOutlineIcon sx={{ color: "#595959" }} />
                        <ListItemText primary={video.title} />
                      </ListItemIcon>
                    </ListItem>
                  ))}
                </List>
              </AccordionDetails>
            </Accordion>
          ))}
          {[...Array(10)].map((_, index) => (
            <Accordion
              key={index}
              defaultExpanded
              sx={{ backgroundColor: "#F3F3F3", mb: 1 }}
            >
              <AccordionSummary sx={{ py: 1 }} expandIcon={<ExpandMoreIcon />}>
                <Typography
                  fontSize={{ xs: "14.96px", md: "18px" }}
                  fontWeight={700}
                  color={"#233F91"}
                >
                  Definition and Scope of Psychology
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">
                  Detailed content description here...
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))} */}
        </Box>
      )}
    </Box>
  );
};

export default HandOutContent;

const styleSheet = {
  downloadBtn: {
    width: "24px",
    height: "24px",
  },
  pdfListItem: {
    display: "flex",
    alignItems: "center",
    gap: 2,
  },
};
